<template>
  <div class="grid" style="align-items: stretch">

    <!-- White Jar -->
     <div class="col-12 md:col-6 lg:col-3 product-card-wrapper" data-aos="zoom-in" data-aos-once="true">
      <Card class="product-card">
        <template #header>
          <div class="header-wrapper">
            <img :src="mgo1050Image" class="product-image"/>
          </div>
        </template>
        <template #title>
          <div class="center-text card-title">
            <span class="block">Mā</span>
          </div>
        </template>
        <template #subtitle>
          <div class="center-text card-subtitle">
            White Label<br><br>
            1050+ MGO<br>
            24+ UMF
          </div>
        </template>
        <template #content>
          <div v-if="buyActive" class="buy-button" id='product-component-1650704134979'></div>
          <p class="honey-card-text">Our rarest and our most prized honey, Mā is rated at 1050+ MGO. This Mānuka blend is the most luxurious and coveted of our range. Indulge in the lavish quality and taste of authentic New Zealand honey with unmistakable health benefits. </p>
        </template>
      </Card>
    </div>

    <!-- Black Jar -->
    <div class="col-12 md:col-6 lg:col-3 product-card-wrapper" data-aos="zoom-in" data-aos-once="true">
      <Card class="product-card">
        <template #header>
          <div class="header-wrapper">
            <img :src="mgo800Image" class="product-image"/>
          </div>
        </template>
        <template #title>
          <div class="center-text card-title">
            <span class="block">Pango</span>
          </div>
        </template>
        <template #subtitle>
          <div class="center-text card-subtitle">
            Black Label<br><br>
            800+ MGO<br>
            20+ UMF
          </div>
        </template>
        <template #content>
          <p class="honey-card-text">With MGO content of 800+, only a very small taste of Pango is needed to claim the benefits of New Zealand's Mānuka honey. Soft, sweet and rich in flavour, this honey is a treat to savour.</p>
        </template>
      </Card>
    </div>

    <!-- Orange Jar -->
    <div class="col-12 md:col-6 lg:col-3 product-card-wrapper" data-aos="zoom-in" data-aos-once="true">
      <Card class="product-card">
        <template #header>
          <div class="header-wrapper">
            <img :src="mgo600Image" class="product-image"/>
          </div>
        </template>
        <template #title>
          <div class="center-text card-title">
            <span class="block">Karaka</span>
          </div>
        </template>
        <template #subtitle>
          <div class="center-text card-subtitle">
            Orange Label<br><br>
            600+ MGO<br>
            16+ UMF
          </div>
        </template>
        <template #content>
          <p class="honey-card-text">At 600+ MGO, Karaka honey is a great option for experiencing the medicinal effects of Mānuka honey. Luxurious and velvety, this honey effortlessly drips into teas or is easy to enjoy straight off your spoon.</p>
        </template>
      </Card>
    </div>

    <!-- Red Jar -->
    <div class="col-12 md:col-6 lg:col-3 product-card-wrapper" data-aos="zoom-in" data-aos-once="true">
      <Card class="product-card">
        <template #header>
          <div class="header-wrapper">
            <img :src="mgo500Image" class="product-image"/>
          </div>
        </template>
        <template #title>
          <div class="center-text card-title">
            <span class="block">Whero</span>
          </div>
        </template>
        <template #subtitle>
          <div class="center-text card-subtitle">
            Red Label<br><br>
            500+ MGO<br>
            15+ UMF
          </div>
        </template>
        <template #content>
          <p class="honey-card-text">Our MGO honey Whero 500+ is concentrated for your use. Just a small spoonful daily can bring you positive health benefits with that quality New Zealand honey taste.</p>
        </template>
      </Card>
    </div>

    <!-- Green Jar -->
    <div class="col-12 md:col-6 lg:col-3 product-card-wrapper" data-aos="zoom-in" data-aos-once="true">
      <Card class="product-card">
        <template #header>
          <div class="header-wrapper">
            <img :src="mgo400Image" class="product-image"/>
          </div>
        </template>
        <template #title>
          <div class="center-text card-title">
            <span class="block">Kākāriki</span>
          </div>
        </template>
        <template #subtitle>
          <div class="center-text card-subtitle">
            Green Label<br><br>
            400+ MGO<br>
            12+ UMF
          </div>
        </template>
        <template #content>
          <p class="honey-card-text">At 400+ MGO, you can really taste the classic true flavour of New Zealand Mānuka honey in Kākāriki. The remarkable properties are sure to help you start your day with an extra spring in your step.</p>
        </template>
      </Card>
    </div>

    <!-- Blue Jar -->
    <div class="col-12 md:col-6 lg:col-3 product-card-wrapper" data-aos="zoom-in" data-aos-once="true">
      <Card class="product-card">
        <template #header>
          <div class="header-wrapper">
            <img :src="mgo300Image" class="product-image"/>
          </div>
        </template>
        <template #title>
          <div class="center-text card-title">
            <span class="block">Kikorangi</span>
          </div>
        </template>
        <template #subtitle>
          <div class="center-text card-subtitle">
            Blue Label<br><br>
            300+ MGO<br>
            10+ UMF
          </div>
        </template>
        <template #content>
          <p class="honey-card-text">Our 300+ MGO Kikorangi honey is great value for people wanting to dip their toes into the world of superfood honey without compromising on quality, taste or health benefits.</p>
        </template>
      </Card>
    </div>

    <!-- Pink Jar -->
    <div class="col-12 md:col-6 lg:col-3 product-card-wrapper" data-aos="zoom-in" data-aos-once="true">
      <Card class="product-card">
        <template #header>
          <div class="header-wrapper">
            <img :src="mgo200Image" class="product-image"/>
          </div>
        </template>
        <template #title>
          <div class="center-text card-title">
            <span class="block">Māwhero</span>
          </div>
        </template>
        <template #subtitle>
          <div class="center-text card-subtitle">
            Pink Label<br><br>
            200+ MGO<br>
            8+ UMF
          </div>
        </template>
        <template #content>
          <p class="honey-card-text">Our ataahua (beautiful) 200+ MGO honey is our newest and most affordable product on the market. Great for coughs and colds or to sweeten your favourite winter beverage or summer smoothie.</p>
        </template>
      </Card>
    </div>

    <!-- Lozenges -->
    <div class="col-12 md:col-6 lg:col-3 product-card-wrapper" data-aos="zoom-in" data-aos-once="true">
      <Card class="product-card">
        <template #header>
          <div class="header-wrapper">
            <img :src="losengesImage" class="product-image"/>
          </div>
        </template>
        <template #title>
          <div class="center-text card-title">
            <span class="block">Lozenges</span>
          </div>
        </template>
        <template #subtitle>
          <div class="center-text card-subtitle">
            Gold Label<br><br>
            400+ MGO<br>
            12+ UMF
          </div>
        </template>
        <template #content>
          <p class="honey-card-text">Our pure Mānuka honey lozenges provide all of the same qualities as our 400+ Kākāriki honey with the extra benefit of easily taking it to the office or popping in your bag on a day out.</p>
        </template>
      </Card>
    </div>

    <div class="warning-wrapper center-text top-padding bottom-padding">
      <p class="informational-text">*Mānuka honey products are not suitable for children under 12 months old</p>
    </div>

  </div>
</template>

<script>
export default {
  name: 'CardSection',

  props: {

  },

  mounted() {
    if(this.buyActive){

      let test = document.createElement('script');
      test.innerText = '/*<![CDATA[*/\
      (function () {\
      var scriptURL = "https://sdks.shopifycdn.com/buy-button/latest/buy-button-storefront.min.js";\
      if (window.ShopifyBuy) {\
      if (window.ShopifyBuy.UI) {\
      ShopifyBuyInit();\
    } else {\
      loadScript();\
    }\
    } else {\
      loadScript();\
    }\
      function loadScript() {\
      var script = document.createElement("script");\
      script.async = true;\
      script.src = scriptURL;\
      (document.getElementsByTagName("head")[0] || document.getElementsByTagName("body")[0]).appendChild(script);\
      script.onload = ShopifyBuyInit;\
    }\
      function ShopifyBuyInit() {\
      var client = ShopifyBuy.buildClient({\
      domain: "wero-testing1.myshopify.com",\
      storefrontAccessToken: "6e6913a20382fe22262c1092f5c183e4",\
    });\
      ShopifyBuy.UI.onReady(client).then(function (ui) {\
      ui.createComponent("product", {\
      id: "7662393098497",\
      node: document.getElementById("product-component-1650704134979"),\
      moneyFormat: "%24%7B%7Bamount%7D%7D",\
      options: {\
      "product": {\
      "styles": {\
      "product": {\
      "@media (min-width: 601px)": {\
      "max-width": "calc(25% - 20px)",\
      "margin-left": "20px",\
      "margin-bottom": "50px"\
    }\
    },\
      "button": {\
      "font-family": "Avant Garde, sans-serif",\
      ":hover": {\
      "background-color": "#000000"\
    },\
      "background-color": "#000000",\
      ":focus": {\
      "background-color": "#000000"\
    }\
    }\
    },\
      "contents": {\
      "img": false,\
      "button": false,\
      "buttonWithQuantity": true,\
      "title": false,\
      "price": false\
    },\
      "text": {\
      "button": "Add to cart"\
    }\
    },\
      "productSet": {\
      "styles": {\
      "products": {\
      "@media (min-width: 601px)": {\
      "margin-left": "-20px"\
    }\
    }\
    }\
    },\
      "modalProduct": {\
      "contents": {\
      "img": false,\
      "imgWithCarousel": true,\
      "button": false,\
      "buttonWithQuantity": true\
    },\
      "styles": {\
      "product": {\
      "@media (min-width: 601px)": {\
      "max-width": "100%",\
      "margin-left": "0px",\
      "margin-bottom": "0px"\
    }\
    },\
      "button": {\
      "font-family": "Avant Garde, sans-serif",\
      ":hover": {\
      "background-color": "#000000"\
    },\
      "background-color": "#000000",\
      ":focus": {\
      "background-color": "#000000"\
    }\
    }\
    },\
      "text": {\
      "button": "Add to cart"\
    }\
    },\
      "option": {},\
      "cart": {\
      "styles": {\
      "button": {\
      "font-family": "Avant Garde, sans-serif",\
      ":hover": {\
      "background-color": "#000000"\
    },\
      "background-color": "#000000",\
      ":focus": {\
      "background-color": "#000000"\
    }\
    }\
    },\
      "text": {\
      "total": "Subtotal",\
      "notice": "",\
      "button": "Checkout"\
    },\
      "contents": {\
      "note": true\
    }\
    },\
      "toggle": {\
      "styles": {\
      "toggle": {\
      "font-family": "Avant Garde, sans-serif",\
      "background-color": "#000000",\
      ":hover": {\
      "background-color": "#000000"\
    },\
      ":focus": {\
      "background-color": "#000000"\
    }\
    }\
    }\
    }\
    },\
    });\
    });\
    }\
    })();\
      /*]]>*/';


      document.getElementById("product-component-1650704134979").appendChild(test);

    }
  },

  data() {
    return {
      buyActive: false,
      mgo1050Image: require("../../assets/images/wero clearcuts 1050mgo cropped.png"),
      mgo800Image: require("../../assets/images/wero clearcuts 800mgo cropped.png"),
      mgo600Image: require("../../assets/images/wero clearcuts 600mgo cropped.png"),
      mgo500Image: require("../../assets/images/wero clearcuts 500mgo cropped.png"),
      mgo400Image: require("../../assets/images/wero clearcuts 400mgo cropped.png"),
      mgo300Image: require("../../assets/images/wero clearcuts 300mgo cropped.png"),
      mgo200Image: require("../../assets/images/wero clearcuts 200mgo cropped.png"),
      losengesImage: require("../../assets/images/lozenges Box.png"),
    }
  },

  methods: {

    clickCart: function(){
      // Simulates a click on the cart button
      const cartElement = document.getElementsByClassName("shopify-buy-frame--toggle")[0];
      console.info(cartElement);
      cartElement.click();
    }

  },

  computed: {
    vuex: function(){
      return(this.$store.state);
    },

  },

  watch: {

  }

}

</script>


<style scoped>

  .header-wrapper{
    width: 100%;
    text-align: center;
  }

  .product-card-wrapper{
    display: flex; /*sets equal heights the easy way*/
  }

  .card-title{
    font-size: 2rem;
    font-family: hubballi;
    font-weight: 800;
  }
  .card-subtitle{
    font-size: 1.2rem;
    font-family: hubballi;
    font-weight: 500;
  }
  .honey-card-text{
    font-family: acumin-pro, sans-serif !important;
    font-size: 0.85rem;
    font-weight: 400;
    letter-spacing: 1px;
    line-height: 1.4rem;
    text-align: justify;
  }

  .warning-wrapper{
    width: 100%;
  }

  .product-image{
    padding: 1rem;
    max-width: 350px;
  }

  .buy-button{
    width: 100%;
  }


</style>


